export enum SessionStorageKey {
  'SNACK_PACK' = 'SNACK_PACK'
}
